module.exports = __webpack_public_path__ + "static/MA-3f29ef8c05a5da67eeaed5712213c30a.svg";